import { render } from "./Spinner.vue?vue&type=template&id=499683c2"
const script = {}
script.render = render

export default script